<template>
  <div class="gallery">
    <div class="flex items-center gap-1">
      <div class="w-[8px] h-[8px] rounded-full bg-[#A084E8]" />
      <div class="w-[35px] h-[8px] rounded-full bg-[#A084E8]" />
      <p class="text-[18px] laptop:text-[20px] font-semibold font-roboto pl-2 m-0 text-[#333333]">Gallery</p>
    </div>
  </div>
  <div v-if="isAccordionOpen || !isMobile" class="galleryDes pt-2">
    <!-- Figma SAR Flow "Service & Repair - Details - Step 3" (5506:2063): note, solid "Upload images" + size hint,
         4 thumbnails a page (210x120, 5px #EFEFEF border) with dots; empty state from S&R Details (5504:1281) -->
    <p class="!mb-[15px] text-[14px] font-roboto text-[#333333]">
      <span class="text-[#F67280]">Note:</span> Please avoid uploading any financial
      documents.
    </p>
    <div class="flex flex-wrap items-center gap-[10px] mb-[20px] font-roboto">
      <label
        class="flex items-center justify-center gap-[8px] w-[150px] h-[36px] m-0 rounded-[5px] border-1 border-[#7695FF] bg-[#7695FF] text-[14px] text-white cursor-pointer">
        Upload images
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M7 18a4.5 4.5 0 0 1-.6-8.96A6 6 0 0 1 18 8.5a4 4 0 0 1-.5 7.97M12 12v7m0-7-2.5 2.5M12 12l2.5 2.5"
            stroke="#FFFFFF" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <input ref="fileInput" type="file" class="upload__inputfile" accept="image/*,application/pdf"
          @change="onFileChange">
      </label>
      <span class="text-[12px] text-[#F67280]">(Max file size to upload is 10 MB)</span>
    </div>
    <div v-if="!fileArray || !fileArray.length"
      class="flex flex-col items-center justify-center min-h-[150px] px-[15px] rounded-[10px] border-1 border-dashed border-[#CCCCCC] bg-[#EFEFEF80] text-center font-roboto">
      <p class="m-0 text-[14px] leading-[20px] text-[#000000]">No photos uploaded yet</p>
      <p class="m-0 text-[12px] leading-[20px] text-[#999999]">Add before / after photos to support your evaluation.</p>
    </div>
    <!-- thumbnails, page dots and the photo modal: shared with the Universal Quote images (PhotoGallery) -->
    <PhotoGallery v-else :files="fileArray" alt-text="Job photo" @remove="removeFile" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { useToast } from "vue-toastification";
import PhotoGallery from "../gallery/PhotoGallery.vue";

const toast = useToast();

export default {
  components: { PhotoGallery },

  data() {
    return {
      isAccordionOpen: true,
      isMobile: false,
      fileArray: [],
      maxLength: 10,
    };
  },

  computed: {
    ...mapGetters(["bookingImageUploaded", "bookingDocs", "removeBookingDocs"]),
  },

  watch: {
    bookingDocs: function () {
      this.fileArray = this.bookingDocs;
    },

    removeBookingDocs: function () {
      this.getBookingDocuments();
    },

    bookingImageUploaded: function () {
      this.$refs.fileInput.value = null;

      this.getBookingDocuments();
    },
  },

  mounted() {
    this.getBookingDocuments();
    this.checkMobile();
    window.addEventListener("resize", this.checkMobile);
  },

  beforeUnmount() {
    window.removeEventListener("resize", this.checkMobile);
  },

  methods: {
    ...mapActions([
      "bookingDocumentDelete",
      "uploadBookingImage",
      "getBookingDocs",
    ]),

    getBookingDocuments() {
      this.getBookingDocs({
        booking_id: this.$route.params.id,
      });
    },

    onFileChange(event) {
      this.updateImageDisplay(event);
    },

    updateImageDisplay(e) {
      const fileSize = e.target.files[0].size / 1024 / 1024; // in MiB
      const file = e.target.files[0];
      var type = "image";

      if (file.type === "application/pdf") {
        type = "pdf";
      }

      if (fileSize <= 10) {
        const file = e.target.files[0];
        let url = URL.createObjectURL(file);
        var obj = {
          title: file.name,
          url: url,
          thumbnail: url,
          mime: type,
        };

        this.fileArray = [obj].concat(this.fileArray); // [ 4, 3, 2, 1 ]

        this.uploadImage(e);
      } else {
        toast.error("File size should not be greater than 10MB.");
      }
    },

    uploadImage(e) {
      const file = e.target.files[0];
      let formData = new FormData();
      formData.append("document", file);
      formData.append("booking_id", this.$route.params.id);
      formData.append("title", file.name);
      formData.append("timestamp", new Date().getTime());

      this.uploadBookingImage(formData);
    },

    removeFile(item) {
      this.$dialog.show({
        title: "Delete Image",
        text: "Are you sure you want to delete this document?",
        // we are passing callback method for our confirm button
        onConfirm: () => {
          this.bookingDocumentDelete({
            id: item.id,
            booking_id: this.$route.params.id,
          });
        },
      });

      // this.$swal
      //   .fire({
      //     text: "Are you sure to delete this document?",
      //     icon: "error",
      //     cancelButtonText: "YES",
      //     confirmButtonText: "Cancel",
      //     showCancelButton: true,
      //   })
      //   .then((result) => {
      //     if (!result["isConfirmed"]) {
      //       this.bookingDocumentDelete({
      //         id: item.id,
      //         booking_id: this.$route.params.id,
      //       });
      //     }
      //   });
    },

    toggleEditing(index) {
      let isEditing = this.fileArray[index].editing;
      if (isEditing) {
        this.updateFileName(
          this.fileArray[index].title,
          this.fileArray[index].id
        );
      }
      this.fileArray[index].editing = !this.fileArray[index].editing;
      if (this.fileArray[index].editing) {
        this.$nextTick(() => {
          this.$refs.editInput[index].focus();
        });
      }
    },

    updateFileName(title, id) {
      let formData = new FormData();
      formData.append("booking_id", this.$route.params.id);
      formData.append("title", title);
      formData.append("timestamp", new Date().getTime());
      formData.append("id", id);

      this.uploadBookingImage(formData);
    },

    toggleAccordion() {
      this.isAccordionOpen = !this.isAccordionOpen;
    },
    checkMobile() {
      this.isMobile = window.innerWidth <= 767;
    },
  },
};
</script>

<style>
.accordion-icon {
  transition: transform 0.3s;
  color: #fff;
  font-size: 20px;
}

.accordion-icon.rotated {
  transform: rotate(180deg);
}

@media (min-width: 768px) {

  /* .notesBody {
    display: none;
  }
  .notesBody[open] {
    display: block;
  } */
  .accordion-icon {
    display: none;
  }
}
</style>
